import { render, staticRenderFns } from "./WeekReport.vue?vue&type=template&id=010c96c2&"
import script from "./WeekReport.vue?vue&type=script&lang=js&"
export * from "./WeekReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/WeekReport.vue
// module id = null
// module chunks = 